//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	props: ['resident', 'alreadyblacklisted'],
	data: function data() {
		return {
			blacklist: false,
			confirm: false
		};
	},

	computed: {
		blacklistText: function blacklistText() {
			if (this.alreadyblacklisted) {
				return 'restore';
			}

			if (this.isMovedOut) {
				return 'restore';
			}

			return 'remove';
		},
		blacklistTitle: function blacklistTitle() {
			if (this.alreadyblacklisted || this.isMovedOut) {
				return 'Restore Portal Access';
			}

			return 'Remove Portal Access';
		},
		isAlreadyBlacklisted: function isAlreadyBlacklisted() {
			return this.alreadyblacklisted || false;
		},
		isMovedOut: function isMovedOut() {
			return this.resident.current_status === "Move Out";
		}
	},
	methods: {
		process: function process() {
			var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;


			if (this.alreadyblacklisted || this.isMovedOut) {
				this.sendUnBlacklist();
			} else {
				this.sendBlacklist(type);
			}
		},
		sendBlacklist: function sendBlacklist(type) {
			var self = this;
			var sendData = {
				resident: self.resident.id,
				type: type
			};

			window.axios.post('/prototype/person/resident/blacklist', sendData).then(function (response) {
				if (response.data === 'no email') {
					self.$snotify.success(self.resident.full_name + ' is now blacklisted');
				}
				Event.$emit("update-resident-detail");
				Event.$emit('check-blacklist');
			});

			this.closeModal();
		},
		sendUnBlacklist: function sendUnBlacklist() {
			var self = this;
			var sendData = {
				resident: self.resident.id
			};

			window.axios.post('/prototype/person/resident/unblacklist', sendData).then(function (response) {
				if (response.data === 'no email') {
					self.$snotify.success(self.resident.full_name + ' is now unblacklisted');
				}
				Event.$emit("update-resident-detail");
				Event.$emit('check-blacklist');
			});

			this.closeModal();
		},

		closeModal: function closeModal() {
			Event.$emit('close-small-modal', 'resident-confirm-blacklist');
		},
		residentConfirmBlacklist: function residentConfirmBlacklist() {
			var self = this;
			Event.$emit('show-small-modal', false, false, 'resident-confirm-blacklist');
			self.$children[0].$data.showSmallModal = true;
		}
	},
	created: function created() {
		Event.$on('resident-confirm-blacklist', this.residentConfirmBlacklist);
	},
	beforeDestroy: function beforeDestroy() {
		Event.$off('resident-confirm-blacklist');
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentConfirmBlacklist.vue
// module id = dnbY
// module chunks = 0 1